<script setup lang="ts">

import {useDialogPluginComponent} from "quasar";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import ChatView from "@/views/ChatView.vue";
import ChatSidebar from "@/components/navBar/chat/ChatSidebar.vue";
import ChatPresenter from "@/utils/presenters/ChatPresenter.ts";
import {computed, onMounted, ref} from "vue";
import ChatInfoBar from "./ChatInfoBar.vue";

const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const loginStore = useLoginInfoStore();
const presenter = new ChatPresenter();
const chatSidebarRef = ref<InstanceType<typeof ChatSidebar>>();
const chatInfoBarRef = ref<InstanceType<typeof ChatInfoBar>>();
const chatViewRef = ref<InstanceType<typeof ChatView>>();
const showChatInfo = ref(false);
const isOtherUserOnline = computed(() => {
  const meta = presenter.currentChatMetadata.value;
  if (meta?.chatConversationType !== 'Direct')
    return false;
  const otherParticipant = meta.participants?.find(p => p.participant?.id !== presenter.currentUserInfo?.id);
  if (!otherParticipant?.participant?.id)
    return false;
  return presenter.isUserOnline(otherParticipant.participant.id);
});
onMounted(async () => {
  await presenter.start();
})

function toggleSideBar() {
  if (chatSidebarRef.value)
    chatSidebarRef.value.toggleSideBar();
}

function toggleChatInfo() {
  if (chatInfoBarRef.value && chatInfoBarRef.value)
    chatInfoBarRef.value.toggleChatInfo();
}
</script>

<template>
  <q-dialog v-if="loginStore.isLoggedIn" persistent ref="dialogRef" @hide="onDialogCancel" >
    <q-layout view="hHh Lpr lff" container style="min-height: 100%; max-height: 100%;"
              class="nama-chat-layout tw-border-rounded tw-shadow-none tw-overflow-hidden dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light tw-h-full tw-w-full">
      <q-header class="tw-text-xs tw-text-namaFontColor-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-fit">
        <q-toolbar class="tw-h-10 tw-min-h-fit">
          <NamaIcon default-icon="nm-menu" id="chatToolsSideBarBtn" @click="toggleSideBar" class="tw-size-4 tw-cursor-pointer"/>
          <q-toolbar-title v-text="Translator.translateId('chats') +' - Beta Version'"
                           class="tw-text-lg tw-font-semibold mobile:tw-hidden"/>
          <q-space/>
          <NamaIcon default-icon="close" @click="onDialogCancel" :title="Translator.translateId('close')" class="tw-size-5 tw-cursor-pointer"/>
        </q-toolbar>
      </q-header>
      <ChatSidebar ref="chatSidebarRef" :presenter="presenter" @closeChatInfo="showChatInfo = false"/>
      <ChatInfoBar ref="chatInfoBarRef" :presenter="presenter" :isOtherUserOnline="isOtherUserOnline"/>
      <q-page-container class="tw-h-full tw-w-full !tw-pt-0 tw-overflow-hidden">
        <q-page class="tw-flex tw-flex-col  tw-h-full tw-w-full tw-pt-10 tw-overflow-hidden">
          <ChatView ref="chatViewRef" :presenter="presenter" :isOtherUserOnline="isOtherUserOnline" @toggleChatInfo="toggleChatInfo"/>
        </q-page>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>

<style>

</style>
